<template>

    <div class="com-list-video-x">
        <ul>
            <li v-for="item in list">
                <a :href="tplGetRecommendHref(item)" class="block" :target="tplGetRecommendTarget(item)">
                    <div class="rel cover-image" :style="tplGetStyle(item)">
                        <div v-if="item.type === 2 && !item.link" class="play-mask"></div>
                    </div>

                    <p class="el">{{item.title}} <!--<span>共{{item.nums || 0}}期</span>--></p>
                </a>
            </li>
        </ul>
    </div>

</template>

<script>
import Utils from "@/utils/utils";

export default {
    props: {
        list: {
            type: Array,
            value: []
        }
    },

    data() {
        return {}
    },

    created() {

    },

    methods: {
        tplGetRecommendHref(item) {
            return Utils.getRecommendHref(item)
        },

        tplGetRecommendTarget(item) {
            return Utils.getRecommendTarget(item)
        },


        tplGetStyle(item) {
            return {backgroundImage: `url("${item.covers}")`}
        }
    }

}
</script>

<style lang="less" scoped>

.com-list-video-x {

    .cover-image {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        transition: all 0.3s;

        width: 281px;
        height: 158px;

        //&:hover {
        //    transform: scale3d(1.1, 1.1, 1.1);
        //}
    }

    .play-mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        background-image: url('../../assets/img/video-play.png');
        background-size: 40px;
        background-position: center;
        background-repeat: no-repeat;
        transition: all 0.3s;

        &:hover {
            background-color: rgba(0, 0, 0, 0);
            background-image: none;
        }
    }


    ul {
        display: flex;
        justify-content: space-between;

        li {
            width: 281px;
            height: 228px;
            font-size: 16px;
            cursor: pointer;


            span {
                font-size: 12px;
                color: #a21717
            }

            img {
                transition: transform .5s;
            }

        }


        li:hover {
            img {
                transform: scale(1.1);
                transition: transform .5s;
            }
        }
    }


}


</style>
